export default __webpack_public_path__ + "static/media/Logo.d17e5892.svg";